import { ColDef } from '@ag-grid-community/core'
import React from 'react'
import { CensusFileRowStatusEnum } from '../../api/enums/census-file-row-status.enum'
import { CensusFileRowTypeEnum } from '../../api/enums/census-file-row-type.enum'
import { CensusFileRowGridData } from '../../types/census-file-row-grid-data'
import { CensusManagementPageProps } from '../../types/census-management-page-props'
import { formatCensusFileRowTypeLabel } from '../../utils/format-census-file-row-type-label'
import ReviewRecordsBase from '../components/CensusReviewRecordsBase'

const statusColumn: ColDef<CensusFileRowGridData> = {
  headerName: 'Status',
  field: 'status',
  width: 150,
  sortable: true,
  pinned: 'left',
  valueFormatter: (params) => {
    if (!params.value) return ''
    return params.value
      .toLowerCase()
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
      .join(' ')
  },
  cellStyle: (params): Record<string, string> => {
    switch (params.value) {
      case CensusFileRowStatusEnum.IN_REVIEW:
        return { color: '#D48806', fontWeight: '500' } // Yellow/Orange
      case CensusFileRowStatusEnum.WITHDRAWN:
      case CensusFileRowStatusEnum.REJECTED:
      case CensusFileRowStatusEnum.DELETED:
        return { color: '#CE6C6D', fontWeight: '500' } // Red
      case CensusFileRowStatusEnum.COMPLETE:
        return { color: '#28A745', fontWeight: '500' } // Green
      default:
        return {}
    }
  },
}

const typeColumn: ColDef<CensusFileRowGridData> = {
  headerName: 'Type',
  field: 'type',
  width: 100,
  sortable: true,
  valueFormatter: (params) => {
    return formatCensusFileRowTypeLabel(params.value, params.data?.status)
  },
  cellStyle: (): Record<string, string> => ({
    fontWeight: '500',
  }),
}

const updatedAtCol: ColDef<CensusFileRowGridData> = {
  headerName: 'Last Updated',
  field: 'updatedAt',
  width: 200,
  sortable: true,
  valueFormatter: (params) => {
    const date = new Date(params.value)
    if (isNaN(date.getTime())) {
      return params.value
    }
    return date.toLocaleString()
  },
}

// Show errors on page
const CensusReviewRecordsActivity = (props: CensusManagementPageProps) => {
  const modifyColDefs = (
    baseColDefs: ColDef<CensusFileRowGridData>[]
  ): ColDef<CensusFileRowGridData>[] => {
    return [statusColumn, typeColumn, updatedAtCol, ...baseColDefs]
  }

  return (
    <>
      <ReviewRecordsBase
        pageTitle={'Review New & Updated Records'}
        tabKey={'activity'}
        {...props}
        rowQueryParams={{
          censusRowType: [
            CensusFileRowTypeEnum.UPDATE_EMPLOYEE_BENEFITS,
            CensusFileRowTypeEnum.UPDATE_EMPLOYEE_NO_BENEFITS,
            CensusFileRowTypeEnum.DRAFT_EMPLOYEE,
            CensusFileRowTypeEnum.ERROR,
            CensusFileRowTypeEnum.DUPLICATE_EMPLOYEE,
          ],
          censusFileRowStatuses: [CensusFileRowStatusEnum.IN_REVIEW],
          excludeMatch: true,
        }}
        modifyColDefs={modifyColDefs} // Pass the callback function here
        showSearch
      />
    </>
  )
}

export default CensusReviewRecordsActivity
